let EUY = {}

EUY.autoHeight = (obj, num) => {
  
  let H = document.documentElement.clientHeight

  if (obj.length == 1) {

    obj[0].style.height = H - num + 'px'
  
  } else {

      obj.forEach(function(e){  
        e.style.height = H - num + 'px'
      })
    
  }
}  

EUY.GetStorage = (key) => {

  // console.log(localStorage.getItem(key))
  if(localStorage.getItem(key) && localStorage.getItem(key) != 'undefined' ){

    return JSON.parse(localStorage.getItem(key))
    
  }else{
    return ''
  }
    // 
}

EUY.SetStorage = (key, data) => {
  window.localStorage.setItem(key, window.JSON.stringify(data))
}

EUY.RemoveStorage = (key) => {
  return window.localStorage.removeItem(key)
}

  

export default EUY


// WEBPACK FOOTER //
// ./src/common/scripts/euy.js